module.exports = __webpack_public_path__ + "img/UT0359.164d6622.png";